import { ImageBackground, SafeAreaView, View } from 'react-native';
import React, { useCallback, useEffect } from 'react';
import { Button, Text } from '~/components';
import PaymentErrorSVG from '~/assets/svgs/checkoutPaymentError.svg';
import { useCheckout, useSalesFunnel } from '~/stores';
import { isWeb } from '~/utils/device';
import useAppNavigation from '~/hooks/useAppNavigation';
import { CheckoutStepNames } from '~/utils/salesFunnel';

const CheckoutError = () => {
  const { navigate, pop } = useAppNavigation();
  const { insurance } = useCheckout();
  const { newStepLog } = useSalesFunnel();

  const tryAgain = useCallback(() => {
    pop(2);
  }, [pop]);

  useEffect(() => {
    newStepLog(CheckoutStepNames.ERROR);
  }, [newStepLog]);

  return (
    <SafeAreaView className="bg-white flex-1 items-center justify-center lg:flex-row">
      <ImageBackground
        source={insurance?.banner.web || {}}
        className="w-[518px] h-[669px] hidden lg:block"
      />

      <View className="items-center justify-center px-8 lg:ml-28 flex-1 lg:flex-none">
        <PaymentErrorSVG />

        <Text className="text-center text-xl text-gray-600 mt-8 w-[250px]">
          Houve um erro no processamento do pagamento via cartão de crédito
        </Text>

        <Button
          className="hidden lg:flex mx-4 mt-28 w-[250px]"
          onPress={tryAgain}
        >
          Tentar novamente
        </Button>

        <Button
          className="hidden lg:flex mx-4 mt-4 w-[250px]"
          onPress={() => navigate('MarisaServicos_Home')}
          variant="secondary"
        >
          Voltar para Home
        </Button>
      </View>

      <View className="lg:hidden border-t border-t-gray-100 w-[100%]">
        <Button
          className={`mt-4 mx-4 ${isWeb ? 'mb-4' : ''}`}
          onPress={tryAgain}
        >
          Tentar novamente
        </Button>
      </View>
    </SafeAreaView>
  );
};

export default CheckoutError;
